import React, { useContext, useEffect } from 'react'
import { Container } from 'reactstrap'
import { withRouter } from 'react-router-dom'
import { GeneralContext } from '../../context/'
import PersonalizationTemplatesManager from './components/PersonalizationTemplatesManager'

const Index = () => {
    const { setBreadcrumb } = useContext(GeneralContext)

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: 'Personalizados',
            parentLink: '/personalization-mockups',
            item: 'Mockups'
        })
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <h2>Mockups de personalizados</h2>
                    <PersonalizationTemplatesManager />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Index)
